module.exports = __webpack_public_path__ + "img/seychelles.ad5d9080.svg";